import {clsx, type ClassValue} from 'clsx'
import {twMerge} from 'tailwind-merge'

export function mergeClasses(...args: ClassValue[]) {
  return twMerge(clsx(args))
}
